import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { ScheduledGrocery } from '@/models/scheduledGrocery';

export const fetchScheduledGrocery = async (id: number): Promise<ScheduledGrocery> => {
  const response = await queryExecute({
    query: graphql(`
      query ScheduledGrocery($id: Float!) {
        scheduledGrocery(id: $id) {
          id
          callerId
          groceryStoreId
          isMultiple
          scheduleTime
          scheduleDate
          endOn
          timeZone
          endAfterXTimes
          day0
          day1
          day2
          day3
          day4
          day5
          day6
          repeatEveryXWeek
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          latitude
          longitude
          address
          tip
          isLeaveAtDoor
          noteToShopper
          completedAt
          executedAt
          preauthorizedChargeAt
          minutesBeforeCustomReminder
          calledCustomReminderAt
          emailedReminderAt
          calledReminderAt
          emailedUnpaidServicesAt
          calledUnpaidServicesAt
          emailedPreauthFailedAt
          calledPreauthFailedAt
          canceledAt
          cancellationReason
          canceledById
          operatorId
          skipScheduledGroceryDates
          localScheduleTimeDisplayString
          updatedAt
          createdAt
          dateTimes
          groceries {
            orderId
            createdAt
          }
          caller {
            id
            firstName
            lastName
          }
          operator {
            id
            firstName
            lastName
          }
          canceledByUser {
            id
            firstName
            lastName
            roles
            role
          }
          store {
            id
            name
            slug
            logo
            storeId
          }
          storeItems {
            id
            scheduledGroceryId
            groceryItemId
            replacementItemId
            replacementItemQty
            qty
            instruction
            replacementPolicy
            groceryItem {
              id
              name
              img
              unit
              size
              price
              productId
              productName
              createdAt
              updatedAt
              itemId
              groceryProduct {
                id
                name
                createdAt
                updatedAt
              }
            }
            replacementItem {
              id
              name
              img
              unit
              size
              price
              productId
              productName
              createdAt
              updatedAt
              itemId
              groceryProduct {
                id
                name
                createdAt
                updatedAt
              }
            }
          }
        }
      }
    `),
    variables: {
      id,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.scheduledGrocery;
};
